import { Skeleton, Stack } from '@mui/material';
import { GridBody, GridCell, GridHead, GridRow, MainPageGrid } from '@schooly/style';
import { FC } from 'react';

import { MARKBOOK_FOR_GROUPS_STUDENTS_COL_WIDTH } from '../common/assessmentStyling';
import { MarkbookStudentNameSkeletonCell } from '../common/MarkbookCell';

const PAGE_SIZE = 30;

type MarkbookPreviewSkeletonTableProps = {
  pageSize?: number;
};

export const MarkbookPreviewSkeletonTable: FC<MarkbookPreviewSkeletonTableProps> = ({
  pageSize = PAGE_SIZE,
}) => {
  return (
    <Stack
      gap={1}
      sx={{
        height: '100%',
        overflow: 'hidden',
        '& .MuiSkeleton-rectangular': {
          borderRadius: 0.5,
        },
      }}
    >
      <MainPageGrid
        sx={(theme) => ({
          height: '100%',
          '& .MuiTableCell-root': {
            borderColor: `${theme.palette.divider} !important`,
          },
        })}
      >
        <GridHead borderBottom sx={{ height: 102 }}>
          <GridRow>
            <GridCell
              borderRight
              borderTop
              borderBottom
              noVerticalPadding
              sx={{
                minWidth: MARKBOOK_FOR_GROUPS_STUDENTS_COL_WIDTH,
                width: MARKBOOK_FOR_GROUPS_STUDENTS_COL_WIDTH,
                pt: 0,
                verticalAlign: 'top',
              }}
            >
              <Stack height={20} justifyContent="center">
                <Skeleton variant="rectangular" width={134} />
              </Stack>
            </GridCell>

            {Array.from({ length: 5 }).map((_, index) => (
              <GridCell
                sx={{
                  verticalAlign: 'top',
                }}
                borderTop
                key={index}
                borderRight
                borderBottom
              >
                <Stack justifyContent="center" gap={2}>
                  <Stack direction="row" gap={1} pt={0.25}>
                    <Skeleton variant="rectangular" width={46} height={46} />
                    <Stack gap={0.25} flex={1} pt={0.75}>
                      <Skeleton variant="rectangular" width="90%" height={16} />
                      <Skeleton variant="rectangular" width="40%" height={16} />
                    </Stack>
                  </Stack>
                  <Skeleton variant="rectangular" width="30%" height={22} />
                </Stack>
              </GridCell>
            ))}
          </GridRow>
        </GridHead>
        <GridBody>
          <GridRow withoutDefaultHover>
            <GridCell noVerticalPadding>
              <Stack direction="row" alignItems="center" gap={1} sx={{ py: 1.5 }}>
                <Skeleton variant="rectangular" width="95%" height={20} />
              </Stack>
            </GridCell>
            {Array.from({ length: 5 }).map((_, colIndex, array) => (
              <GridCell
                key={colIndex}
                sx={{ minWidth: 120 }}
                borderRight={colIndex === array.length - 1}
              />
            ))}
          </GridRow>
          {Array.from({ length: pageSize }).map((_, rowIndex) => (
            <GridRow key={rowIndex} withoutDefaultHover>
              <GridCell borderRight noVerticalPadding>
                <MarkbookStudentNameSkeletonCell sx={{ py: 1 }} />
              </GridCell>
              {Array.from({ length: 5 }).map((_, colIndex) => (
                <GridCell key={colIndex} borderRight sx={{ minWidth: 120 }} />
              ))}
            </GridRow>
          ))}
        </GridBody>
      </MainPageGrid>
    </Stack>
  );
};
